module.exports = __webpack_public_path__ + "img/logo_blue.32dd6ac0.svg";